module.exports = __webpack_public_path__ + "img/ticon3.3c2dc49c.png";